<div class="p-col-12">
    <div class="p-text-center">
        <p-progressSpinner [style]="{width: '75px', height: '75px'}"></p-progressSpinner>
    </div>
</div>
